<template>
  <div>
    <!-- Drawer for mobile -->
    <v-layout class="hidden-md-and-up">
      <v-flex>
        <v-toolbar fixed flat color="white">
          <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
          <v-layout justify-center>
            <router-link to="/">
              <img
                src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/318x622.jpg"
                style="height: 2.6rem; padding-top: 3px"
              />
            </router-link>
          </v-layout>
          <v-icon @click="searchToolbar = !searchToolbar">search</v-icon>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <!-- Search toolbar for mobile -->
    <v-layout row wrap v-if="searchToolbar" class="hidden-md-and-up">
      <v-flex xs12>
        <v-toolbar fixed flat color="#211850">
          <v-toolbar-side-icon @click.stop="drawer = !drawer" dark></v-toolbar-side-icon>
          <v-layout row wrap mt-2>
            <v-form @submit.prevent="getSearchResult()">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field v-model="searchMenuMobile" label="Anexos, noticias, etc" clearable dark color="white" append-icon="send" @click:append="getSearchResult()" counter></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-layout>
          <v-icon @click="searchToolbar = !searchToolbar" dark>close</v-icon>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <div class="hidden-md-and-up">
      <v-layout wrap>
        <v-navigation-drawer v-model="drawer" absolute temporary style="position:fixed;">
          <v-list class="pt-3 pb-2 pl-1 pr-3">
            <v-layout justify-space-between row>
              <v-flex>
                <img
                  src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/318x622.jpg"
                  style="height: 2rem;"
                  class="mt-1"
                />
              </v-flex>

              <router-link to="/perfil">
                <v-avatar 
                  v-if="getMenus"
                  size="37px"
                  :color="getMenus.user.color" 
                  >
                  <img
                    :src="getMenus.user.image"
                    style="height: 2.5rem; width: 2.5rem"
                  />
                </v-avatar>
              </router-link>
            </v-layout>
          </v-list>

          <v-list>
            <v-list-tile to="/">
              <v-list-tile-action>
                <v-icon>home</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Inicio</v-list-tile-title>
            </v-list-tile>

            <v-list-group prepend-icon="adjust" v-for="(main_menu, i) in this.getMenus.menus" :key="i">
              <template v-slot:activator>
                <v-list-tile>
                  <v-list-tile-title>
                    {{main_menu.title}}
                    <span :class="`ml-1 w3-badge`" v-if="main_menu.notifications">
                      {{ main_menu.notifications }}
                    </span>
                  </v-list-tile-title>
                </v-list-tile>
              </template>
              <div v-if="main_menu && main_menu.length && main_menu.menus[0].submenus[0].submenus">
                <v-list-group
                  no-action
                  sub-group
                  v-for="(menu,i) in main_menu.menus[0].submenus"
                  :key="i"
                >
                  <template v-slot:activator>
                    <v-list-tile>
                      <v-list-tile-title>{{menu.title}}</v-list-tile-title>
                    </v-list-tile>
                  </template>

                  <v-list-tile
                    v-for="(submenu, i) in menu.submenus"
                    :key="i"
                    :href="getLink(submenu.link)"
                    :disabled="!submenu.mobile"
                  >
                    <v-list-tile-title v-text="submenu.title"></v-list-tile-title>
                    <v-list-tile-action>
                      <v-icon>filter_none</v-icon>
                    </v-list-tile-action>
                  </v-list-tile>
                </v-list-group>
              </div>
              <div>
                <v-list-group no-action sub-group v-for="(menu,i) in main_menu.menus" :key="i">
                  <template v-slot:activator>
                    <v-list-tile>
                      <v-list-tile-title>{{menu.title}}</v-list-tile-title>
                    </v-list-tile>
                  </template>

                  <v-list-tile
                    v-for="(submenu, i) in menu.submenus"
                    :key="i"
                    :href="getLink(submenu.link)"
                    :disabled="!submenu.mobile"
                  >
                    <v-list-tile-title>
                      {{ submenu.title }}
                    </v-list-tile-title>
                    
                    <v-list-tile-action>
                      <i class="material-icons ml-2" style="font-size: 14px" v-if="!submenu.mobile">
                        phonelink_erase
                      </i>
                      <span :class="`ml-1 w3-badge w3-badge-${submenu.badge.type}`" v-if="submenu.badge && submenu.mobile">
                        {{ submenu.badge.text }}
                      </span>
                    </v-list-tile-action>
                  </v-list-tile>
                </v-list-group>
              </div>
            </v-list-group>
          </v-list>
        </v-navigation-drawer>
      </v-layout>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      searchMenuMobile: '',
      searchToolbar: false,
      drawer: false,
      admins: [
        ["Management", "people_outline"],
        ["Settings", "settings"]
      ],
      cruds: [
        ["Create", "add"],
        ["Read", "insert_drive_file"],
        ["Update", "update"],
        ["Delete", "delete"]
      ]
    };
  },
  computed: {
    ...mapGetters("menus", ["getMenus"]),
  },
  mounted() {
    // console.log(this.getMenus.menus);
  },
  methods: {
    goToMenu(link) {
      this.$router.push("`/${link}`");
    },
    getLink(link) {
      if (link && link.indexOf("http") == 0) {
        return link;
      } else {
        return "#/" + link;
      }
    },
    getSearchResult(){
      this.$router.push({name: 'results', params: { query: this.searchMenuMobile}});
    }
  }
};
</script>

<style>
.fa-times-circle{
  margin-right: 30px;
}

.v-form{
  width: 95%;
}

.w3-badge-success {
  color: #FFF!important;
  background-color: #28a745;
}

.w3-badge-warning {
  color: #000!important;
  background-color: #FFD600 !important;
}

.w3-badge-danger {
  color: #FFF;
  background-color: #dc3545;
}

.w3-badge {
  border-radius: 50%;
  background-color: #000;
  color: #fff;
  display: inline-block;
  padding-left: 9px;
  padding-right: 9px;
  text-align: center;
  font-size: 14px;
}
</style>
